'use strict';
module.exports = {};
module.exports.twitterIntentResultDecorator = function (exportResult) {
	exportResult['twitter-url'] =  'https://twitter.com/intent/tweet?text=' + encodeURIComponent(exportResult.export.title) +
		'&url=' + encodeURIComponent(exportResult['index-html']) +
		'&source=mindmup.com&related=mindmup&via=mindmup';
};
module.exports.facebookResultDecorator = function (exportResult) {
	exportResult['facebook-url'] = 'https://www.facebook.com/dialog/share_open_graph?' +
		'app_id=621299297886954' +
		'&display=popup' +
		'&action_type=og.likes' +
		'&action_properties=%7B%22object%22%3A%22' + encodeURIComponent(exportResult['index-html']) + '%22%7D' +
		'&redirect_uri=' + encodeURIComponent('http://www.mindmup.com/fb');
};
module.exports.linkedinResultDecorator = function (exportResult) {
	exportResult['linkedin-url'] = 'http://www.linkedin.com/shareArticle?mini=true' +
		'&url=' + encodeURIComponent(exportResult['index-html']) +
		'&title=' + encodeURIComponent(exportResult.export.title) +
		'&summary=' + encodeURIComponent(exportResult.export.description) +
		'&source=MindMup';

};
module.exports.tumblrResultDecorator = function (exportResult) {
	exportResult['tumblr-url'] = 'http://www.tumblr.com/share/link?url=' + encodeURIComponent(exportResult['index-html']) +
		'&name=' + encodeURIComponent(exportResult.export.title) +
		'&description=' + encodeURIComponent(exportResult.export.description);
};
module.exports.pinterestResultDecorator = function (exportResult) {
	exportResult['pinterest-url'] = 'https://pinterest.com/pin/create/button/?media=' + encodeURIComponent(exportResult['thumb-png']) + '&url=' + encodeURIComponent(exportResult['index-html']) + '&is_video=false&description=' + encodeURIComponent(exportResult.export.description);
};
module.exports.embedResultDecorator = function (exportResult) {
	exportResult['embed-markup'] = '<iframe src="' + exportResult['index-html'] + '"></iframe>';
};

module.exports.gmailResultDecorator = function (exportResult) {
	exportResult['gmail-index-html'] = 'https://mail.google.com/mail/u/0/?view=cm&ui=2&cmid=0&fs=1&tf=1&body=' + encodeURIComponent(exportResult.export.title + '\n\n') + encodeURIComponent(exportResult['index-html']);
};

module.exports.emailResultDecorator = function (exportResult) {
	exportResult['email-index-html'] = 'mailto:?subject=' + encodeURIComponent(exportResult.export.title) + '&body=' + encodeURIComponent(exportResult.export.description + ':\r\n\r\n') + encodeURIComponent(exportResult['index-html']);
};

module.exports.gmailZipResultDecorator = function (exportResult) {
	exportResult['gmail-archive-zip'] = 'https://mail.google.com/mail/u/0/?view=cm&ui=2&cmid=0&fs=1&tf=1&body=' + encodeURIComponent(exportResult.export.title + '\n\n') + encodeURIComponent(exportResult['archive-zip']);
};
module.exports.emailZipResultDecorator = function (exportResult) {
	exportResult['email-archive-zip'] = 'mailto:?subject=' + encodeURIComponent(exportResult.export.title) + '&body=' + encodeURIComponent(exportResult.export.description + ':\r\n\r\n') + encodeURIComponent(exportResult['archive-zip']);
};



